import Select, { Option } from "@ingka/select";

type PropsType = {
  min: number;
  max: number;
  onChange: any;
  label: string;
  id: string;
};

function getOptions(min: number, max: number) {
  const options = [];

  for (let i = min; i <= max; i++) {
    options.push(<Option value={`${i}`} name={`${i}`} key={i} />);
  }

  return options;
}

const QuantityWithLabel = (props: PropsType) => {
  return (
    <Select
      hintText=""
      label={props.label}
      id={props.id}
      onChange={props.onChange}
    >
      {getOptions(props.min, props.max)}
    </Select>
  );
};

export default QuantityWithLabel;
